import moment from "moment"
import { endpoint } from "../../../views/pages/manage/common/constant"
import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData, updateRequest } from "../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { getNextStatus, refundStatusList, refundTypeDropdown } from "./constant"
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function"
export const getDropdowns = async () => {
  const p = await Promise.all([
    dropdownMapping(endpoint.businessArea.getAllActiveV2, 'businessAreaDispValue', 'id', 'businessUnitTypeId'),
    dropdownMapping(endpoint.paymentMode.getActive, 'paymentModeDispValue', 'paymentModeKey'),
    dropdownMapping(endpoint.term.getAllActive, 'termDispValue', 'termDispValue'),
    dropdownMapping(endpoint.businessArea.getCashierOfficeDetails, 'businessAreaDispValue', 'businessAreaDispValue'),
    dropdownMapping(
      endpoint.businessUnitType.getAllBusinessUnitType,
      "businessUnitTypeDispValue",
      "id",
    ),
  ])
  return {
    businessAreas: p[0],
    paymentMode: p[1],
    terms: p[2],
    refundTypes: refundTypeDropdown,
    refundStatus: refundStatusList,
    cashierOffice: p[3],
    branchTypes : p[4]
  }
}

export const getRefundRequests = async ({
  pageNo = 0,
  pageSize = 10,
  filters,
  dropdowns
}) => {
  const businessArea = filters?.businessArea?.length ? filters?.businessArea : dropdowns?.businessAreas;
  const updatedFilters = {
    ...filters,
    refundRequestDateFrom: filters?.refundRequestDateFrom ? moment(filters?.refundRequestDateFrom).startOf('day') : "",
    refundRequestDateTo: filters?.refundRequestDateTo ? moment(filters?.refundRequestDateTo).endOf('day') : "",
    terms: filters?.terms ? [filters?.terms] : [],
    businessArea
  }
  let req = updateRequest({ ...updatedFilters });
  req = {
    ...req,
    // approvalStatusList : updatedStatusList[req.approvalStatus]
  }
  return fetchAllPostPromisedData(`${endpoint.refund.refundApproval.search}?offset=${pageNo}&pageSize=${pageSize}`, req);

}

export const getRefundRequestsApi = async ({
  pageNo = 0,
  pageSize,
  request
}) => {

  return fetchAllPostPromisedData(`${endpoint.refund.refundApproval.search}?offset=${pageNo}&pageSize=${pageSize}`, request);

}

export const getRefundReason = async (subOrderType = '') => {
  try {
    const refundType = subOrderType ? `?refundType=${subOrderType}` : ''
    const res = await fetchAllPromisedData(`${endpoint.refund.refundreason}${refundType}`)
    return (res ?? []).map(item => ({ label: item?.reasonDisplayValue, value: item?.id, ...item }))
  }
  catch (err) {
    console.err(err)
  }
}

export const updateApprovalRequests = async (reqObj) => {
  const req = {
    approvalStatus: getNextStatus(reqObj?.approvalStatus, reqObj?.approvalAction),
    remark: reqObj?.remark,
    refundReasonId: reqObj?.selectedReason,
    beneficiaryName: reqObj?.beneficiaryName,
    paymentAccountDetailsId: reqObj?.paymentModeAccountDetailId
  }
  return await fetchAllPostPromisedData(`${endpoint.refund.refundApproval.update}?refundNumber=${reqObj?.refundNumber}`, updateRequest(req))
}

export const rejectionHandler = async (rejectRequest) => {
  const reasonArray = ["COMPLETION_REFUND"]
  const { orderType, id, approvalStatus, setUpdateStatusInfo, status, refundNumber, approvalAction, isRemarkMandatory, dropdownData, studentBuId } = rejectRequest || {};

  //for frachise completion refund , reasons dropdown to be hidden
  const {businessAreas : allBusinessAreas, branchTypes : allBUTypes} = dropdownData || {};
  const studentBUDetails = allBusinessAreas?.find(bu => bu?.value === studentBuId);
  const studentBUTypeId = studentBUDetails?.businessUnitTypeId[0];
  const studentBUTypeDetails = allBUTypes?.find(buType => buType?.value === studentBUTypeId);
  const isFranchiseBranch = studentBUTypeDetails?.label?.toLowerCase() === 'franchise';

  const rejectionReason = !isFranchiseBranch && reasonArray.includes(orderType) && approvalAction == 'REJECT' && await getRefundReason(orderType) || null

  setUpdateStatusInfo({
    approvalAction: approvalAction,
    dialogInfo: rejectRequest?.dialogInfo ?? { subHeading: "" },
    refundType: rejectRequest?.subOrderType,
    dropdown: rejectionReason,
    id: refundNumber,
    refundNumber,
    status,
    approvalStatus,
    isRemarkMandatory: isRemarkMandatory || false,
    updatedOn: rejectRequest?.updatedOn,
    updatedBy: rejectRequest?.updatedBy,
    isUpdatedDetailRequired: rejectRequest?.isUpdatedDetailRequired || false
  })
}
export const getConfigs = async (filterReqObj) => {
  return await fetchAllPostPromisedData(endpoint.refund.approvalConfig.search, filterReqObj);
}

export const getApprovalPermissions = ({
  approvalConfigResponseDTOList = [],
  roleId,
  approvalRequest = {},
}) => {
  const { businessAreaValue, subOrderType, cashierOffice } = approvalRequest;

  if (!roleId || !subOrderType || !businessAreaValue || !cashierOffice) {
    // Missing critical info , return defaults
    return { isL1Approver: false, isL2Approver: false, isL3Approver: false };
  }

  //handle undefined branchApprovalDtoList or businessArea
  const matchedConfigs = approvalConfigResponseDTOList.filter(item =>
    Array.isArray(item?.branchApprovalDtoList?.[0]?.businessArea) &&
    item.branchApprovalDtoList?.[0]?.businessArea.includes(businessAreaValue) &&
    Array.isArray(item?.branchApprovalDtoList?.[0]?.cashier) &&
    item.branchApprovalDtoList?.[0]?.cashier.includes(cashierOffice)
  );

  let l1 = false, l2 = false, l3 = false;

  for (const item of matchedConfigs) {
    for (const appr of item?.approvalConfigResponseDTOList ?? []) {
      if (appr?.subType !== subOrderType) continue;

      if (!l1 && Array.isArray(appr?.roleApprovals?.LEVEL_1)) {
        l1 = appr.roleApprovals.LEVEL_1.includes(roleId);
      }
      if (!l2 && Array.isArray(appr?.roleApprovals?.LEVEL_2)) {
        l2 = appr.roleApprovals.LEVEL_2.includes(roleId);
      }
      if (!l3 && Array.isArray(appr?.roleApprovals?.LEVEL_3)) {
        l3 = appr.roleApprovals.LEVEL_3.includes(roleId);
      }

      //break early if all found
      if (l1 && l2 && l3) break;
    }
    if (l1 && l2 && l3) break;
  }

  return { isL1Approver: l1, isL2Approver: l2, isL3Approver: l3 };
};

export const updateApprovalRequest = (list, dropdowns, roleId, approvalConfigs, completionReasonList) => {

  const { businessAreas } = dropdowns;
  return list?.map(el => {
    let reasonDispValue = ''
    if (el?.userReasonId) {
      const reasonObj = (completionReasonList || []).find(item => item?.id == el?.userReasonId)
      reasonDispValue = reasonObj?.reasonDisplayValue || ""
    }
    return {
      ...el,
      // businessArea: businessAreas?.find(bu => bu?.value === el?.outBusinessUnitId),
      ...getApprovalPermissions({ approvalConfigResponseDTOList: approvalConfigs, roleId, approvalRequest: el }),
      remark: reasonDispValue ? `${reasonDispValue} - ${el?.remark || ''}` : el?.remark
    }
  })
}

export const getBenificiaryDetails = async ({ refundNumber, benificiaryType = "STUDENT" }) => {
  try {
    const res = await fetchAllPromisedData(`${endpoint.refund.benificiaryDetails}?refundNumber=${refundNumber}&beneficiaryType=${benificiaryType}`)
    return res;
  }
  catch (err) {
    console.error(err)
  }
  finally {

  }
}

export const exportAndSendCsvToEmail = async (filters, userDetails, dropdowns) => {
  const { firstName, lastName, email, employeeId } = userDetails;
  try {
    const businessArea = filters?.businessArea?.length ? filters?.businessArea : dropdowns?.businessAreas;
    const updatedFilters = {
      ...filters,
      refundRequestDateFrom: filters?.refundRequestDateFrom ? moment(filters?.refundRequestDateFrom).startOf('day') : "",
      refundRequestDateTo: filters?.refundRequestDateTo ? moment(filters?.refundRequestDateTo).endOf('day') : "",
      terms: filters?.terms ? [filters?.terms] : [],
      businessArea
    }
    const req = updateRequest({ ...updatedFilters, userEmail: email, userName: `${firstName || ''} ${lastName || ''}`, userId: employeeId });
    const res = await fetchAllPostPromisedData(`${endpoint.refund.refundApproval.exportAndSendCsvToEmail}`, req);
    if (res?.code === 200) {
      return successToast(res?.message);
    }
  }
  catch (err) {
    console.error("Export and Send CSV Error:", err);
  }
};



export const updatebulkApprovalStatus=async(rows)=>{
// create request object like this [{"approvalStatus":"L1_APPROVED","remark":"","refundNumber":2244867}]
  const req= rows?.map(currentRow=>{
    return {
      refundNumber: currentRow.refundNumber,
      approvalStatus: getNextStatus(currentRow?.approvalStatus, "APPROVE"),
      remark: ""
    }
  })
  try{
    const res= await fetchAllPostPromisedData(`${endpoint.refund.refundApproval.bulkUpdate}`, req);
    if(res?.code === 200){
      return successToast(res?.message);
    }
  }
  catch(err){
    console.error("Bulk Approval Error:", err);
  }
}


